import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "print-table-wrap" }
const _hoisted_2 = { class: "print-table-btn" }
const _hoisted_3 = { class: "main-table" }
const _hoisted_4 = { class: "table-title" }
const _hoisted_5 = ["data-day"]
const _hoisted_6 = ["data-day"]
const _hoisted_7 = { style: {"height":"32px","overflow":"hidden"} }
const _hoisted_8 = { class: "table-user" }
const _hoisted_9 = { class: "table-user__name" }
const _hoisted_10 = { class: "table-user__info" }
const _hoisted_11 = { class: "table-user__info-col" }
const _hoisted_12 = { class: "table-user__position" }
const _hoisted_13 = { class: "table-user__bid" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["data-big"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "print-table-item" }

import { computed, Ref, ref } from 'vue';
import { AdditionalData, DateKeys, NewUser } from '@/types';
import { useStore } from 'vuex';
import { formatName, makeFirstLetterUpper } from '@/utils/main';
import VitaVacationType from '@/components/VitaVacationType.vue';
import { useTableScrollX } from '@/utils/scroll';
import { generatePDF } from '@/utils/print';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaPrintTable',
  setup(__props) {

const { tableScroll, scrollEnd, scrollStart, scrollSmoothStart, scrollSmoothStop } = useTableScrollX();

const store = useStore<Storage>()
const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

const currentMouth = computed<string>(() => {
  return store.getters['getCurrentMoth']
})

const currentDate = computed<Date>(() => {
  return store.getters['getCurrentDate']
})

const days = computed<string[]>(() => {
  return store.getters['getCurrentDays']
})

const dateArr = computed<DateKeys[]>(() => {
  return store.getters['data/timeScheduleKeys']
})

const isVacationOnDay = (timeShift: object | AdditionalData, item: DateKeys) => {
  if (!timeShift) return
  return (timeShift[item.key] && (timeShift[item.key][0] && !timeShift[item.key][0].zupGuid))
}

const tableTitle = computed<string>(() => {
  return `График ${makeFirstLetterUpper(currentMouth.value)} ${currentDate.value.getFullYear()}`
})

const pdfContent: Ref<HTMLElement | null> = ref(null);
const btnPrintDisabled = ref(false)

const onClickPrintBtn = async () => {
  btnPrintDisabled.value = true
  if (!pdfContent.value) return;

  try {
    await generatePDF(pdfContent.value)
  } catch (e) {
    console.error(e);
  } finally {
    btnPrintDisabled.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_vita_button = _resolveComponent("vita-button")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vita_button, {
        color: "blue",
        width: "print-btn-action",
        onClick: _withModifiers(onClickPrintBtn, ["prevent"]),
        disabled: btnPrintDisabled.value,
        "data-qa": "print-table-button-print"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Напечатать", -1)),
          _createVNode(_component_vita_icon, {
            class: "btn-elements-icon",
            name: "print"
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_perfect_scrollbar, {
      ref_key: "tableScroll",
      ref: tableScroll
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "print-table",
          id: "printableArea",
          ref_key: "pdfContent",
          ref: pdfContent
        }, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("caption", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(tableTitle.value), 1)
              ])
            ]),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: item + index,
                    "data-day": item
                  }, _toDisplayString(_unref(makeFirstLetterUpper)(item)), 9, _hoisted_5))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("th", null, "ФИО", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: item + index,
                    "data-day": item
                  }, _toDisplayString(index + 1), 9, _hoisted_6))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.zupGuid
                }, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatName)(user.name)), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(user.positionCode), 1),
                          _createElementVNode("div", _hoisted_13, "(" + _toDisplayString(user.bid) + ")", 1)
                        ]),
                        (user.frv && user.frv.frvNorm)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(user.frv ? user.frv.frvNorm : null) + "ч", 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (user.dateArr)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(user.dateArr, (item, position) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: item.key + user.id,
                          "data-big": !!(user.timeShift && user.timeShift[item.key] && user.timeShift[item.key].some(time => time.big)),
                          class: _normalizeClass({ dayOut: dateArr.value[position].dayOut })
                        }, [
                          (user.timeShift)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (isVacationOnDay(user.timeShift, item))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createVNode(VitaVacationType, {
                                        type: user.timeShift[item.key],
                                        user: user,
                                        item: item
                                      }, null, 8, ["type", "user", "item"])
                                    ]))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(user.timeShift[item.key], (time) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: `T-${time.id}`
                                      }, [
                                        (time.status !== 'Canceled' && time.status !== 'MissAccepted')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["table-item-wrap", {'item-big': time.big}])
                                            }, [
                                              _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("div", null, _toDisplayString(time.timeFrom), 1),
                                                _createElementVNode("div", null, _toDisplayString(time.timeTo), 1)
                                              ])
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_15))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_vita_icon, {
      class: "scroll-arrow",
      "data-qa": "print-table-icon-scroll-start",
      onClick: _unref(scrollStart),
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(scrollSmoothStart)(-1)), ["prevent"])),
      onMouseup: _unref(scrollSmoothStop),
      onMouseout: _unref(scrollSmoothStop),
      name: "chevron-left"
    }, null, 8, ["onClick", "onMouseup", "onMouseout"]),
    _createVNode(_component_vita_icon, {
      class: "scroll-arrow scroll-arrow-right",
      "data-qa": "print-table-icon-scroll-end",
      onClick: _unref(scrollEnd),
      onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(scrollSmoothStart)(1)), ["prevent"])),
      onMouseup: _unref(scrollSmoothStop),
      onMouseout: _unref(scrollSmoothStop),
      name: "chevron-left"
    }, null, 8, ["onClick", "onMouseup", "onMouseout"])
  ]))
}
}

})